import React, {InputHTMLAttributes} from "react";
import styles from './RoundIcon.module.scss'

export default function RoundIcon(
  {
    icon, rotating, className, dark, ...props
  }:
  InputHTMLAttributes<HTMLDivElement> & {
    icon: React.ReactNode,
    rotating?: boolean,
    dark?: boolean,
    className?: string
  }) {

  return <div className={`
    ${styles.roundIcon} 
    ${rotating && styles.rotating} 
    ${dark && styles.dark} 
    ${className}
  `} {...props}>
    {icon}
  </div>
}
